import { Phone, Mail, MapPin, Clock } from "lucide-react";
import LeadForm from "@/components/LeadForm";

const Contact = () => {
  const contactInfo = [
    {
      icon: Phone,
      title: "Call or Text",
      content: "781-689-8537",
      subtext: "We're here to help!",
    },
    {
      icon: Mail,
      title: "Email",
      content: "service@521vending.com",
      subtext: "We respond within 24 hours",
    },
    {
      icon: MapPin,
      title: "Service Area",
      content: "Boston & South Shore",
      subtext: "Local & reliable",
    },
    {
      icon: Clock,
      title: "Installation",
      content: "2-3 Weeks",
      subtext: "From approval to operation",
    },
  ];

  return (
    <div className="min-h-screen" data-testid="contact-page">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-navy" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block bg-gold text-navy font-mono text-sm px-4 py-2 rounded-full border-2 border-navy mb-6">
            GET IN TOUCH
          </span>
          <h1 className="font-heading text-4xl md:text-5xl text-cream mb-4">
            Let's Add Value to Your Property
          </h1>
          <p className="text-cream/80 max-w-2xl mx-auto text-lg">
            Ready to offer your tenants, employees, or residents a premium
            refreshment experience? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 -mt-8" data-testid="contact-info-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info) => (
              <div
                key={info.title}
                className="card-retro text-center"
                data-testid={`contact-info-${info.title.toLowerCase()}`}
              >
                <div className="bg-gold/30 w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <info.icon className="h-7 w-7 text-navy" />
                </div>
                <h3 className="font-heading text-lg text-navy mb-1">
                  {info.title}
                </h3>
                <p className="font-bold text-coral">{info.content}</p>
                <p className="text-sm text-navy/60">{info.subtext}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Contact Form */}
      <section className="py-16 md:py-24" data-testid="contact-form-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl border-2 border-navy p-8 md:p-12 shadow-[12px_12px_0px_0px_#F2CC8F]">
            <div className="text-center mb-10">
              <h2 className="font-heading text-3xl text-navy mb-3">
                Request Your Free Vending Solution
              </h2>
              <p className="text-navy/70">
                Complete the form below and our team will contact you within 24
                hours to discuss the perfect solution for your space.
              </p>
            </div>
            <LeadForm variant="full" />
          </div>
        </div>
      </section>

      {/* Benefits Reminder */}
      <section className="py-16 bg-gold/20" data-testid="benefits-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-navy">
              Why Choose 521 Vending?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="font-heading text-5xl text-coral mb-2">$0</div>
              <p className="font-bold text-navy">Cost to You</p>
              <p className="text-sm text-navy/60">
                Equipment, installation, and service included
              </p>
            </div>
            <div className="text-center">
              <div className="font-heading text-5xl text-coral mb-2">24/7</div>
              <p className="font-bold text-navy">Monitoring</p>
              <p className="text-sm text-navy/60">
                Remote monitoring for maximum uptime
              </p>
            </div>
            <div className="text-center">
              <div className="font-heading text-5xl text-coral mb-2">100%</div>
              <p className="font-bold text-navy">Hassle-Free</p>
              <p className="text-sm text-navy/60">
                We handle everything end-to-end
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
